import { motion } from "framer-motion";

import Container from "../../Container/Container";
import IconBox from "../../IconBox/IconBox";
import SectionTitle from "../../SectionTitle/SectionTitle";
import { fadeUp, staggerContainer, viewportOnce } from "../../../Utils/animations";
import { getIcon } from "../../../Utils/iconMap";
import { technologies } from "../../../Data/technologyData";

import "../../../Style/home/technology.css";

function Technology() {
  return (
    <section className="section section--deep-tint technology">
      <Container>
        <SectionTitle
          eyebrow="Technology"
          title="Technology that powers"
          highlight="growth."
          align="center"
        />

        <motion.div
          className="technology__grid"
          variants={staggerContainer(0.06)}
          initial="hidden"
          whileInView="show"
          viewport={viewportOnce}
        >
          {technologies.map((tech) => (
            <motion.div key={tech.id} className="technology__item" variants={fadeUp()}>
              <IconBox icon={getIcon(tech.icon)} size="lg" round />
              <span>{tech.name}</span>
            </motion.div>
          ))}
        </motion.div>
      </Container>
    </section>
  );
}

export default Technology;
